// Frontend configuration
// Runtime-safe WS computation with normalization:
// - If VITE_WS_URL is provided without a path, append "/colyseus"
// - Otherwise, derive from current host
function computeWsUrl(): string {
  const envWs = import.meta.env.VITE_WS_URL as string | undefined;
  if (envWs && envWs.trim().length > 0) {
    try {
      const u = new URL(envWs);
      // If no explicit path provided ("/"), normalize to "/colyseus"
      if (!u.pathname || u.pathname === '/' || u.pathname.trim() === '') {
        u.pathname = '/colyseus';
        return u.toString().replace(/\/$/, '');
      }
      return u.toString().replace(/\/$/, '');
    } catch {
      // If env value is not a full URL, fall back to window-derived URL below
    }
  }
  if (typeof window !== 'undefined' && window.location) {
    const scheme = window.location.protocol === 'https:' ? 'wss' : 'ws';
    return `${scheme}://${window.location.host}/colyseus`;
  }
  // Fallback for non-browser contexts
  return 'ws://localhost:3001/colyseus';
}

export const config = {
  api: {
    // Default to backend dev server (port 3001). Previously this default pointed to the AI engine (3002)
    // which caused the frontend to attempt auth requests against the wrong service and hang at "Checking authentication...".
    baseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) || 'http://localhost:3001',
    wsUrl: computeWsUrl(),
  },
} as const;

export default config;